import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "tiff-namespace"
    }}>{`TIFF namespace`}</h1>
    <p>{`EXIF properties for TIFF-derived data.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`The namespace URI is `}<a parentName="p" {...{
            "href": "http://ns.adobe.com/tiff/1.0/"
          }}>{`http://ns.adobe.com/tiff/1.0/`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The preferred namespace prefix is tiff`}</p>
      </li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Name`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Description`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Type`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:Artist`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Camera owner, photographer or image creator. `}<strong parentName="td">{`NOTE`}</strong>{`: `}<em parentName="td">{`This property is stored in XMP as the first item in the dc:creator array.`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#propername"
            }}>{`ProperName`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:BitsPerSample`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number of bits per component in each channel.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ordered array of `}<a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#integer"
            }}>{`Integer`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:Compression`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Compression scheme. `}<inlineCode parentName="td">{`1 = Uncompressed`}</inlineCode>{` , `}<inlineCode parentName="td">{`6 = JPEG`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Closed Choice of `}<a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#integer"
            }}>{`Integer`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:Copyright`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Copyright information as an ASCII string. `}<strong parentName="td">{`NOTE`}</strong>{`: `}<em parentName="td">{`This property is stored in XMP as dc:rights.`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#language-alternative"
            }}>{`Language Alternative`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:DateTime`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Date and time when the file was last modified (no time zone in EXIF), stored in ISO 8601 format, not the original EXIF format. This property includes the value for the EXIF SubSecTime(37520, 0x9290) attribute. `}<strong parentName="td">{`NOTE`}</strong>{`: `}<em parentName="td">{`This property is stored in XMP as xmp:ModifyDate.`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#date"
            }}>{`Date`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:ImageDescription`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The title of the image as an ASCII string. `}<strong parentName="td">{`NOTE`}</strong>{`: `}<em parentName="td">{`This property is stored in XMP as dc:description.`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#language-alternative"
            }}>{`Language Alternative`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:ImageLength`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Image height in pixels.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#integer"
            }}>{`Integer`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:ImageWidth`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Image width in pixels.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#integer"
            }}>{`Integer`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:Make`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Manufacturer of recording equipment as an ASCII string.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#propername"
            }}>{`ProperName`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:Model`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Model name or number of equipment as an ASCII string.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#propername"
            }}>{`ProperName`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:Orientation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Orientation. `}<inlineCode parentName="td">{`1 = 0th row at the top,0th column at left`}</inlineCode>{`,        `}<inlineCode parentName="td">{`2 = 0th row at the top,0th column at right`}</inlineCode>{`,         `}<inlineCode parentName="td">{`3 = 0th row at the bottom,0th column at right`}</inlineCode>{`,         `}<inlineCode parentName="td">{`4 = 0th row at the bottom,0th column at left`}</inlineCode>{`,         `}<inlineCode parentName="td">{`5 = 0th row at the left,0th column at top`}</inlineCode>{`,         `}<inlineCode parentName="td">{`6 = 0th row at the right,0th column at top`}</inlineCode>{`,         `}<inlineCode parentName="td">{`7 = 0th row at the right,0th column at bottom`}</inlineCode>{`,        `}<inlineCode parentName="td">{`8 = 0th row at the left,0th column at bottom`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Closed Choice of `}<a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#integer"
            }}>{`Integer`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:PhotometricInterpretation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pixel Composition. `}<inlineCode parentName="td">{`2 = RGB`}</inlineCode>{`, `}<inlineCode parentName="td">{`6 = YCbCr`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Closed Choice of `}<a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#integer"
            }}>{`Integer`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:PlanarConfiguration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Data layout. `}<inlineCode parentName="td">{`1 = chunky`}</inlineCode>{`, `}<inlineCode parentName="td">{`2 = planar`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Closed Choice of `}<a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#integer"
            }}>{`Integer`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:PrimaryChromaticities`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Chromaticity of the three primary colors.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ordered array of `}<a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#rational"
            }}>{`Rational`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:ReferenceBlackWhite`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Reference black and white point values.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ordered array of `}<a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#rational"
            }}>{`Rational`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:ResolutionUnit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Unit used for XResolution and YResolution. Value is one of `}<inlineCode parentName="td">{`2 = Inches`}</inlineCode>{`, `}<inlineCode parentName="td">{`3 = Centimeters`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Closed Choice of `}<a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#integer"
            }}>{`Integer`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:SamplesPerPixel`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number of components per pixel.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#integer"
            }}>{`Integer`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:Software`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Software or firmware used to generate image. `}<strong parentName="td">{`NOTE`}</strong>{`: `}<em parentName="td">{`This property is stored in XMP as xmp:CreatorTool.`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#agent-name"
            }}>{`AgentName`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:TransferFunction`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Transfer function for image described in tabular style with 3 * 256 entries.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ordered array of `}<a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#integer"
            }}>{`Integer`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:WhitePoint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Chromaticity of white point.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ordered array of `}<a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#rational"
            }}>{`Rational`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:XResolution`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Horizontal resolution in pixels per unit.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#rational"
            }}>{`Rational`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:YResolution`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Vertical resolution in pixels per unit.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#rational"
            }}>{`Rational`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:YCbCrCoefficients`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Matrix coefficients for RGB to YCbCr transformation.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ordered array of `}<a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#rational"
            }}>{`Rational`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:YCbCrPositioning`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Position of chrominance vs. luminance components. `}<inlineCode parentName="td">{`1 = centered`}</inlineCode>{`, `}<inlineCode parentName="td">{`2 = co-sited`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Closed Choice of `}<a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#integer"
            }}>{`Integer`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tiff:YCbCrSubSampling`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sampling ratio of chrominance components.         `}<inlineCode parentName="td">{`[2,1] = YCbCr4:2:2`}</inlineCode>{`,        `}<inlineCode parentName="td">{`[2,2] = YCbCr4:2:0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ordered array of `}<a parentName="td" {...{
              "href": "./XMPDataTypes/index.md#integer"
            }}>{`Integer`}</a></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      